import formatPrice from '../../../../helpers/formatPrice';
import { formatToNearestTen } from '../../../../helpers/maths';
import { FilterTypes } from '../../../../modules/sortAndFilter/workers/sortAndFilter';
import { PriceBracket } from '../../../../modules/sortAndFilter/config/SortAndFilterConfig';
import Filter from './Filter';

const formatPriceBracketLabel = (bracket: PriceBracket) => {
    const [min, max] = bracket;

    if (max > 99900) {
        return `${formatPrice(formatToNearestTen(min))} or more`;
    }

    if (min === 0) {
        return `${formatPrice(formatToNearestTen(max))} or less`;
    }

    return `${formatPrice(formatToNearestTen(min))} - ${formatPrice(formatToNearestTen(max))}`;
};

class PriceFilter extends Filter<string> {
    constructor(type: FilterTypes['type'], urlKey: string) {
        super(type, urlKey);
        this.setKeysFromUrl();
    }

    formatFilterTypeKeys = () => {
        const keys = Array.from(this.keys);
        return keys.map((key) => key.split('-').map(Number));
    };

    formatTagLabel = (key: string) => {
        const priceBreak = key.split('-').map(Number) as PriceBracket;
        return formatPriceBracketLabel(priceBreak);
    };
}

export default PriceFilter;
